// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-global-loader {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.45);
  pointer-events: all;
}
.app-global-loader ::ng-deep .app-circular-loader {
  color: #64748b;
}
.app-global-loader ::ng-deep .app-circular-loader .app-circular-loader__spinner {
  border-color: #e2e8f0;
  border-top-color: var(--undp-jtf-primary-color, #2563eb);
}`, "",{"version":3,"sources":["webpack://./libs/core/loading/global-loader.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qCAAA;EACA,mBAAA;AACF;AACE;EACE,cAAA;AACJ;AACI;EACE,qBAAA;EACA,wDAAA;AACN","sourcesContent":[".app-global-loader {\n  position: fixed;\n  inset: 0;\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.45);\n  pointer-events: all;\n\n  ::ng-deep .app-circular-loader {\n    color: #64748b;\n\n    .app-circular-loader__spinner {\n      border-color: #e2e8f0;\n      border-top-color: var(--undp-jtf-primary-color, #2563eb);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
